/* Pure Alchemy cart offers: preview gifts are visual; stale real gift lines get reconciled on cart updates. */
(() => {
  "use strict";

  if (window.__paCartOffersLoaded) return;
  window.__paCartOffersLoaded = !0;
  const _ = "cart-drawer.pa-offers-enabled",
    E = '[data-pa-offer-root="cart-page"]',
    A = `${_},${E}`,
    O = "pa-cart-offer-config-v1",
    z = () => {
      try {
        return sessionStorage.getItem(O) || localStorage.getItem(O) || "";
      } catch {
        return "";
      }
    },
    W = l => {
      try {
        const e = JSON.stringify(l);
        sessionStorage.setItem(O, e), localStorage.setItem(O, e);
      } catch {}
    },
    x = "[data-pa-cart-line]",
    g = (l, e = 0) => Number.isFinite(+l) ? +l : e,
    P = (l, e) => Object.entries(e).reduce((t, [a, r]) => t.replaceAll(`{${a}}`, r), String(l || "")),
    $ = new Map(),
    C = (l, e = "INR") => {
      l = Math.max(0, Math.round(g(l)));
      const t = l % 100 ? 2 : 0,
        a = `${e}:${t}`;
      try {
        return $.has(a) || $.set(a, new Intl.NumberFormat(document.documentElement.lang || "en-IN", {
          style: "currency",
          currency: e,
          minimumFractionDigits: t,
          maximumFractionDigits: t
        })), $.get(a).format(l / 100);
      } catch {
        return `\u20B9${(l / 100).toFixed(t)}`;
      }
    },
    G = l => {
      const e = String(l || "").replace(/[^0-9.,-]/g, "").trim();
      if (!e) return 0;
      let t = e.replace(/,/g, "");
      const a = Number.parseFloat(t);
      return Number.isFinite(a) ? Math.max(0, Math.round(a * 100)) : 0;
    };
  class J {
    constructor(e) {
      this.drawer = e, this.isCartPage = e.dataset.paOfferRoot === "cart-page", this.config = this.readConfig(), this.currency = this.config.currency || "INR", this.freebieIds = new Set(this.config.freebies.map(t => t.variantId)), this.excludedProductIds = new Set(this.config.excludedProductIds), this.tierMap = new Map(this.config.tiers.map(t => [t.originalIndex, t])), !this.isCartPage && this.drawer.querySelector("[data-pa-offer-config]") && W(this.config), this.config.enabled && this.drawer.classList.add(this.isCartPage ? "pa-cart-page-offers-enabled" : "pa-offers-enabled"), this.render();
    }
    readConfig() {
      const e = this.drawer.querySelector("[data-pa-offer-config]") || document.querySelector("[data-pa-global-offer-config]"),
        t = this.isCartPage ? document.querySelector("[data-pa-cart-page-config]") : null,
        a = (e == null ? void 0 : e.textContent) || this.isCartPage && (z() || (t == null ? void 0 : t.textContent)) || "";
      if (!a) return {
        enabled: !1,
        tiers: [],
        freebies: [],
        excludedProductIds: []
      };
      try {
        const c = JSON.parse(a || "{}");
        return c.tiers = (c.tiers || []).map((n, o) => ({
          ...n,
          originalIndex: o
        })).filter(n => n && n.enabled !== !1).map(n => ({
          ...n,
          basis: n.basis === "order_value" ? "order_value" : "quantity",
          qty: Math.max(1, g(n.qty, 1)),
          amount: Math.max(0, g(n.amount)),
          value: Math.max(0, g(n.value)),
          type: ["percent", "free", "freebie"].includes(n.type) ? n.type : "percent",
          code: String(n.code || "").trim()
        })), c.excludedProductIds = (c.excludedProductIds || []).map(String), c.freebies = (c.freebies || []).map((n, o) => ({
          ...n,
          originalIndex: o,
          enabled: (n == null ? void 0 : n.enabled) !== !1,
          productId: String((n == null ? void 0 : n.productId) || ""),
          variantId: String((n == null ? void 0 : n.variantId) || ""),
          threshold: Math.max(0, g(n == null ? void 0 : n.threshold)),
          maxThreshold: Math.max(0, g(n == null ? void 0 : n.maxThreshold)),
          available: (n == null ? void 0 : n.available) !== !1
        })).filter(n => n.variantId), c;
      } catch (c) {
        return console.warn("[Pure Alchemy cart offers] Invalid configuration.", c), {
          enabled: !1,
          tiers: [],
          freebies: [],
          excludedProductIds: []
        };
      }
    }
    endpoint(e) {
      var t, a;
      return `${((a = (t = window.Shopify) == null ? void 0 : t.routes) == null ? void 0 : a.root) || "/"}${String(e).replace(/^\/+/, "")}`;
    }
    async post(e, t) {
      const a = await fetch(this.endpoint(e), {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify(t)
        }),
        r = await a.json().catch(() => ({}));
      if (!a.ok) throw new Error((r == null ? void 0 : r.description) || (r == null ? void 0 : r.message) || `Cart request failed (${a.status})`);
      return r;
    }
    async changeLine(e, t) {
      var i;
      if (!e || !((i = this.drawer) != null && i.isConnected)) return !1;
      const a = Math.max(0, Math.floor(g(t))),
        r = this.lines().find(s => s.lineKey === e);
      if (!r || this.freebieIds.has(r.variantId)) return false;
      try {
        if (r) {
          if (this.drawer._paInternalMutation = !0, !a) r.element.remove();else {
            r.element.dataset.paQuantity = String(a);
            const h = r.element.querySelector("input.quantity__input");
            h && (h.value = a);
          }
          this.render();
        }
        // This request changes only the merchandise line the shopper edited.
        // KwikCheckout owns all configured gift additions and adjustments.
        const c = {
            [e]: a
          },
          n = this.drawer.dataset.sectionId || this.drawer.dataset.id || this.drawer.id || "",
          o = n ? {
            sections: [n],
            sections_url: `${location.pathname}${location.search}`
          } : {},
          p = await this.post("cart/update.js", {
            updates: c,
            ...o
          });
        const finalCart = await this.removeUnqualifiedFreebies(p, o);
        return this.reindexFromCart(finalCart), n && this.replaceDrawer(finalCart == null ? void 0 : finalCart.sections, n) || (this._allocationSig = "", this.render()), !0;
      } catch (s) {
        return console.warn("[Pure Alchemy cart offers] Unable to update cart line.", s), !1;
      } finally {
        setTimeout(() => {
          this.drawer && (this.drawer._paInternalMutation = !1);
        }, 0);
      }
    }
    async removeUnqualifiedFreebies(cart, sectionOptions = {}) {
      const items = Array.isArray(cart?.items) ? cart.items : [];
      const giftVariants = new Map(this.config.freebies.filter(gift => gift.variantId).map(gift => [gift.variantId, gift]));
      if (!items.length || !giftVariants.size) return cart;
      const paidItems = items.filter(item => {
        const id = String(item.variant_id || item.id || "");
        const lineTotal = Math.max(0, g(item.final_line_price, g(item.line_price)));
        return !giftVariants.has(id) && lineTotal > 0;
      });
      const subtotal = paidItems.reduce((sum, item) => sum + Math.max(0, g(item.final_line_price, g(item.line_price))), 0);
      const updates = {};
      for (const item of items) {
        const gift = giftVariants.get(String(item.variant_id || item.id || ""));
        if (!gift || !item.key) continue;
        const qualifies = gift.enabled && gift.available && paidItems.length > 0 &&
          subtotal >= gift.threshold && (!gift.maxThreshold || subtotal <= gift.maxThreshold);
        if (!qualifies) updates[String(item.key)] = 0;
      }
      if (!Object.keys(updates).length) return cart;
      try {
        return await this.post("cart/update.js", { updates, ...sectionOptions });
      } catch (error) {
        console.warn("[Pure Alchemy cart offers] Could not remove an unqualified gift.", error);
        return cart;
      }
    }
    replaceDrawer(e, t) {
      const a = t && (e == null ? void 0 : e[t]);
      if (!a) return !1;
      const r = new DOMParser().parseFromString(a, "text/html");
      if (this.isCartPage) {
        const y = r.querySelector("#MainCartItems");
        return y ? (L.delete(this.drawer), this.drawer.replaceWith(y), setTimeout(() => v(y), 0), !0) : !1;
      }
      const i = r.querySelector("cart-drawer");
      if (!i) return !1;
      const s = this.drawer.querySelector("[data-pa-offer-config]"),
        c = i.querySelector("[data-pa-offer-config]");
      s && c && (s.textContent = c.textContent);
      const n = this.drawer.querySelector("#CartDrawer-CartItems"),
        o = i.querySelector("#CartDrawer-CartItems"),
        p = this.drawer.querySelector(".drawer__footer-bottom-total"),
        h = i.querySelector(".drawer__footer-bottom-total");
      this.drawer._paInternalMutation = !0;
      try {
        if (n && o) {
          n.className = o.className, n.innerHTML = o.innerHTML, p && h && (p.innerHTML = h.innerHTML);
          const d = i.querySelector(".drawer__heading .cart-count"),
            f = this.drawer.querySelector(".drawer__heading .cart-count");
          return d && f && !f.dataset.paOriginalCount && (f.textContent = d.textContent), this._allocationSig = "", this.render(), !0;
        }
        const y = this.drawer.querySelector(".drawer__body"),
          S = i.querySelector(".drawer__body");
        return y && S ? (y.className = S.className, y.style.cssText = S.style.cssText, y.innerHTML = S.innerHTML, L.delete(this.drawer), setTimeout(() => v(this.drawer), 0), !0) : !1;
      } finally {
        setTimeout(() => {
          this.drawer && (this.drawer._paInternalMutation = !1);
        }, 0);
      }
    }
    async refreshFromServer() {
      if (!this.drawer || !this.drawer.isConnected) return !1;
      if (this._paServerRefreshPromise) return this._paServerRefreshPromise;
      const e = this.drawer.dataset.sectionId || this.drawer.dataset.id || this.drawer.id || "";
      if (!e) return this.render(), !1;
      return this._paServerRefreshPromise = (async () => {
        this.drawer.dataset.paPriceSyncing = "true";
        try {
          const t = Date.now(),
            a = await fetch(`${this.endpoint("cart.js")}?pa_price_sync=${t}`, {
              method: "GET",
              credentials: "same-origin",
              cache: "no-store",
              headers: {
                Accept: "application/json"
              }
            }),
            r = await a.json().catch(() => ({}));
          if (!a.ok) throw new Error(`Cart state refresh failed (${a.status})`);
          if (!this.drawer || !this.drawer.isConnected) return !1;

          const i = Array.isArray(r == null ? void 0 : r.items) ? r.items : [],
            s = [...new Set(i.map(n => String((n == null ? void 0 : n.handle) || "").trim()).filter(Boolean))],
            c = new Map();

          // Fetch the live catalog price for every product currently in the cart.
          // Product API prices are returned in the shopper's presentment currency.
          await Promise.all(s.map(async n => {
            try {
              const o = await fetch(`${this.endpoint(`products/${encodeURIComponent(n)}.js`)}?pa_price_sync=${t}`, {
                  method: "GET",
                  credentials: "same-origin",
                  cache: "no-store",
                  headers: {
                    Accept: "application/json"
                  }
                }),
                p = await o.json().catch(() => null);
              o.ok && p && c.set(n, p);
            } catch (o) {
              console.warn(`[Pure Alchemy cart offers] Unable to verify current price for ${n}.`, o);
            }
          }));

          const n = [];
          for (const o of i) {
            const p = String((o == null ? void 0 : o.handle) || "").trim(),
              h = String((o == null ? void 0 : o.variant_id) || (o == null ? void 0 : o.id) || ""),
              u = c.get(p);
            if (!p || !h || !u || this.freebieIds.has(h) || (o == null ? void 0 : o.parent_relationship) || (o == null ? void 0 : o.has_components)) continue;
            const m = Array.isArray(u.variants) ? u.variants.find(y => String((y == null ? void 0 : y.id) || "") === h) : null;
            if (!m) continue;

            let y = g(m.price, -1);
            const S = o == null ? void 0 : o.selling_plan_allocation,
              d = String((S == null ? void 0 : S.selling_plan) && S.selling_plan.id || "");
            if (d) {
              const f = Array.isArray(m.selling_plan_allocations) ? m.selling_plan_allocations.find(w => String((w == null ? void 0 : w.selling_plan_id) || "") === d) : null;
              if (!f) continue;
              y = g(f.price, -1);
            }

            const f = g(o == null ? void 0 : o.original_price, -1);
            y >= 0 && f >= 0 && y !== f && n.push(o);
          }

          if (n.length) {
            // Shopify can keep an existing cart line at the price captured when the
            // line was created. Recreate only the lines whose catalog price changed.
            // Quantity, line-item properties and selling plan are preserved.
            const o = {};
            n.forEach(p => {
              const h = String((p == null ? void 0 : p.key) || "");
              h && (o[h] = 0);
            });
            Object.keys(o).length && await this.post("cart/update.js", {
              updates: o
            });

            const p = n.map(h => {
              const u = {
                id: h.variant_id || h.id,
                quantity: Math.max(1, Math.floor(g(h.quantity, 1)))
              },
                m = h.properties && typeof h.properties === "object" ? h.properties : null,
                y = h.selling_plan_allocation && h.selling_plan_allocation.selling_plan ? h.selling_plan_allocation.selling_plan.id : null;
              m && Object.keys(m).length && (u.properties = m), y && (u.selling_plan = y);
              return u;
            });
            p.length && await this.post("cart/add.js", {
              items: p
            });
          }

          // Render the drawer from the final authoritative cart state on every open.
          const o = await fetch(`${this.endpoint("cart.js")}?pa_price_render=${Date.now()}`, {
              method: "GET",
              credentials: "same-origin",
              cache: "no-store",
              headers: {
                Accept: "application/json"
              }
            }),
            p = await o.json().catch(() => ({}));
          if (!o.ok) throw new Error(`Final cart refresh failed (${o.status})`);
          if (!this.drawer || !this.drawer.isConnected) return !1;

          const cleanedCart = await this.removeUnqualifiedFreebies(p),
            h = Array.isArray(cleanedCart == null ? void 0 : cleanedCart.items) ? cleanedCart.items : [],
            u = {};
          h.forEach(m => {
            const y = String((m == null ? void 0 : m.key) || "");
            y && (u[y] = Math.max(0, Math.floor(g(m == null ? void 0 : m.quantity))));
          });

          const m = await this.post("cart/update.js", {
            updates: u,
            sections: [e],
            sections_url: `${location.pathname}${location.search}`
          });
          if (!this.drawer || !this.drawer.isConnected) return !1;
          return this.reindexFromCart(m), this.replaceDrawer(m == null ? void 0 : m.sections, e) ? !0 : (this._allocationSig = "", this.render(), !1);
        } catch (t) {
          return console.warn("[Pure Alchemy cart offers] Unable to recalculate cart prices.", t), !1;
        } finally {
          this.drawer && delete this.drawer.dataset.paPriceSyncing, this._paServerRefreshPromise = null;
        }
      })(), this._paServerRefreshPromise;
    }
    setLineIndex(e, t) {
      if (!(e instanceof Element)) return;
      const a = Math.max(1, Math.floor(g(t)) + 1);
      e.dataset.paLineIndex = String(a - 1), e.querySelectorAll("input.quantity__input[data-index]").forEach(r => {
        r.dataset.index = String(a);
      }), e.querySelectorAll("cart-remove-button[data-index],main-cart-remove-button[data-index]").forEach(r => {
        r.dataset.index = String(a);
      });
    }
    reindexVisibleLines() {
      [...this.drawer.querySelectorAll(x)].map(t => ({
        element: t,
        oldIndex: Math.max(0, g(t.dataset.paLineIndex, 0))
      })).sort((t, a) => t.oldIndex - a.oldIndex).forEach((t, a) => this.setLineIndex(t.element, a));
    }
    reindexFromCart(e) {
      const t = Array.isArray(e == null ? void 0 : e.items) ? e.items : [];
      if (!t.length) {
        this.reindexVisibleLines();
        return;
      }
      const a = new Map(t.map((r, i) => [String(r.key || ""), i]));
      for (const r of this.drawer.querySelectorAll(x)) {
        const i = String(r.dataset.paLineKey || "");
        a.has(i) && this.setLineIndex(r, a.get(i));
      }
    }
    bestFreebie(e) {
      let t = null;
      for (const a of this.config.freebies) {
        if (!a.enabled || !a.available || e < a.threshold || a.maxThreshold && e > a.maxThreshold) continue;
        (!t || a.threshold > t.threshold || a.threshold === t.threshold && a.originalIndex < t.originalIndex) && (t = a);
      }
      return t;
    }
    giftPreview(lines) {
      // This card has no Shopify line key, quantity input, or cart action.
      // Only the real cart rows participate in counts, offers, and totals.
      const previews = [...this.drawer.querySelectorAll("[data-pa-freebie-preview]")];
      const paidLines = lines.filter(line => !line.complimentary && line.quantity > 0);
      const subtotal = paidLines.reduce((total, line) => total + Math.max(0, line.lineTotal), 0);
      const gift = paidLines.length && subtotal > 0 ? this.bestFreebie(subtotal) : null;
      const hasActualGift = lines.some(line => line.quantity > 0 &&
        (this.freebieIds.has(line.variantId) || line.element.dataset.paConfiguredFreebie === "true"));
      const parent = lines[0]?.element.parentElement;

      // Existing gifts belong to checkout. Never delete or replace their cart rows.
      if (!gift || hasActualGift || !parent) {
        previews.forEach(card => card.remove());
        return;
      }

      let card = previews.shift();
      previews.forEach(extra => extra.remove());
      const title = String(gift.title || "Complimentary gift");
      const imageURL = String(gift.image || "");
      const value = Math.max(0, g(gift.price), g(gift.compareAtPrice));
      const signature = JSON.stringify([gift.variantId, title, imageURL, value, this.currency]);
      if (!card) {
        card = document.createElement("div");
        card.className = "pa-gift-preview";
        card.dataset.paFreebiePreview = "true";
        card.setAttribute("role", "group");
        card.innerHTML = `
          <img class="pa-gift-preview__image" alt="" width="82" height="82" hidden>
          <div class="pa-gift-preview__details">
            <p class="pa-gift-preview__title"></p>
            <div class="pa-free-price">
              <span class="pa-free-zero"></span><s hidden></s>
            </div>
            <div class="pa-gift-preview__meta">
              <span class="pa-complimentary-badge">FREE</span>
              <div class="pa-gift-preview__quantity-control" role="img" aria-label="Complimentary gift quantity 1, fixed">
                <span class="pa-gift-preview__quantity-side" aria-hidden="true">−</span>
                <span class="pa-gift-preview__quantity-number" aria-hidden="true">1</span>
                <span class="pa-gift-preview__quantity-side" aria-hidden="true">+</span>
              </div>
            </div>
          </div>`;
      }
      if (card.dataset.paPreviewSignature !== signature) {
        card.dataset.paPreviewSignature = signature;
        card.dataset.paPreviewVariantId = gift.variantId;
        card.setAttribute("aria-label", `${title} — free gift at checkout`);
        card.querySelector(".pa-gift-preview__title").textContent = title;
        card.querySelector(".pa-free-zero").textContent = C(0, this.currency);
        const price = card.querySelector("s");
        price.hidden = value <= 0;
        price.textContent = value > 0 ? C(value, this.currency) : "";
        const image = card.querySelector("img");
        image.hidden = true;
        image.removeAttribute("src");
        if (imageURL) {
          try {
            const url = new URL(imageURL, location.href);
            if (["http:", "https:"].includes(url.protocol)) {
              image.src = url.href;
              image.hidden = false;
            }
          } catch {}
        }
      }
      if (card.parentElement !== parent || parent.lastElementChild !== card) parent.appendChild(card);
    }
    lines() {
      return [...this.drawer.querySelectorAll(x)].map((e, t) => {
        e.dataset.paManaged = "1";
        const a = e.querySelector("input.quantity__input"),
          r = g(e.dataset.paQuantity),
          i = Math.max(0, g(a == null ? void 0 : a.value, r)),
          s = Math.max(0, g(e.dataset.paUnitPrice)),
          c = Math.max(0, g(e.dataset.paLineTotal, s * i)),
          n = i === r ? c : s * i,
          o = Math.max(0, g(e.dataset.paMrpUnitPrice)),
          p = e.querySelector(".compare-at-price"),
          h = G(p == null ? void 0 : p.textContent),
          u = Math.max(s, o, h),
          m = Math.max(0, g(e.dataset.paMrpLineTotal)),
          y = m > 0 ? m : u * i,
          S = String(e.dataset.paProductId || ""),
          d = String(e.dataset.paVariantId || ""),
          f = e.dataset.paTitle || "",
          w = this.isCartPage && /^\s*🎁/u.test(f),
          b = this.freebieIds.has(d) || w || e.dataset.paComplimentary === "true" || n === 0;
        return {
          element: e,
          lineIndex: g(e.dataset.paLineIndex, t),
          lineKey: e.dataset.paLineKey || "",
          productId: S,
          variantId: d,
          title: f,
          quantity: i,
          unitPrice: s,
          lineTotal: n,
          mrpUnitPrice: u,
          mrpLineTotal: y,
          complimentary: b,
          eligible: e.dataset.paEligible !== "false" && !b && !this.excludedProductIds.has(S) && i > 0
        };
      });
    }
    tierMet(e, t, a) {
      return (e == null ? void 0 : e.basis) === "order_value" ? a >= Math.max(0, g(e.amount)) : t >= Math.max(1, g(e.qty, 1));
    }
    tierFor(e, t) {
      let a = null;
      return this.config.tiers.forEach(r => {
        this.tierMet(r, e, t) && (a = r);
      }), a;
    }
    nextTier(e, t, a = null) {
      const r = a ? this.config.tiers.findIndex(i => i.originalIndex === a.originalIndex) + 1 : 0;
      for (let i = Math.max(0, r); i < this.config.tiers.length; i += 1) {
        const s = this.config.tiers[i];
        if (!this.tierMet(s, e, t)) return s;
      }
      return null;
    }
    calculate(e, t, a = null, r = null) {
      a || (a = e.filter(o => o.eligible));
      let i, s, c;
      if (r) i = r.eligibleQuantity, s = r.eligibleTotal, c = r.rawTotal;else {
        i = 0, s = 0, c = 0;
        for (const o of e) o.complimentary || (c += o.lineTotal), o.eligible && (i += o.quantity, s += o.lineTotal);
      }
      const n = new Map();
      let p = (t == null ? void 0 : t.type) === "percent" ? Math.round(s * t.value / 100) : 0;
      if ((t == null ? void 0 : t.type) === "free") {
        let o = Math.max(0, Math.floor(t.value));
        const h = [...a].sort((u, m) => u.unitPrice - m.unitPrice || u.lineIndex - m.lineIndex);
        for (const u of h) {
          if (!o) break;
          const m = Math.min(u.quantity, o);
          m && (n.set(u.lineIndex, m), p += u.unitPrice * m, o -= m);
        }
      }
      return p = Math.min(p, c), {
        rawTotal: c,
        eligibleTotal: s,
        eligibleQuantity: i,
        discountAmount: p,
        finalTotal: Math.max(0, c - p),
        freeByLine: n
      };
    }
    render() {
      this.isCartPage && this.drawer.querySelectorAll("[data-pa-banner-prev],[data-pa-banner-next]").forEach(e => e.remove());
      if (!this.config.enabled) return;
      const e = this.lines(),
        t = [];
      let a = 0,
        r = 0,
        i = 0;
      for (const n of e) n.complimentary || (i += n.lineTotal), n.eligible && (t.push(n), a += n.quantity, r += n.lineTotal);
      const s = this.tierFor(a, r),
        c = this.nextTier(a, r, s),
         discountTier = [...this.config.tiers].reverse().find(tier => tier.type !== "freebie" && this.tierMet(tier, a, r)) || null,
        n = this.calculate(e, discountTier, t, {
          eligibleQuantity: a,
          eligibleTotal: r,
          rawTotal: i
        });
      this.drawer.dataset.paOfferRendered = "true", this.header(a), this.complimentary(e), this.giftStrikePrices(e), this.panel(s, c, n), this.allocations(e, discountTier, n), this.giftPreview(e), this.summary(discountTier, n, e), this.cartPageActions();
    }

    cartPageActions() {
      if (!this.isCartPage) return;
      this.drawer.querySelectorAll("[data-pa-cart-line],[data-pa-free-allocation]").forEach(e => {
        e.style.position = "relative";
        let t = e.querySelector(":scope>.pa-cart-page-actions");
        t || (t = document.createElement("div"), t.className = "pa-cart-page-actions", e.appendChild(t));
        t.style.cssText = "position:absolute;right:24px;top:50%;transform:translateY(-50%);display:flex;flex-direction:column;align-items:center;gap:8px;z-index:3";
        const a = [...e.querySelectorAll("main-cart-edit")],
          r = [...e.querySelectorAll("main-cart-remove-button,cart-remove-button,[data-pa-remove-free-product]")],
          i = e.matches("[data-pa-free-allocation],.pa-free-product-card,.pa-complimentary-line"),
          s = i ? null : a[0],
          c = e.querySelector("[data-pa-remove-free-product]") || r.find(e => e.localName === "main-cart-remove-button") || r[0];
        a.filter(e => e !== s).forEach(e => e.remove()), r.filter(e => e !== c).forEach(e => e.remove()), t.replaceChildren();
        const n = e => {
          e && (e.style.cssText += ";display:inline-flex!important;position:static!important;inset:auto!important;transform:none!important;margin:0!important;padding:0!important;width:24px!important;min-width:24px!important;justify-content:center!important;align-items:center!important", t.appendChild(e));
        };
        n(s), n(c), s || c || t.remove();
        const o = e.getBoundingClientRect();
        e.querySelectorAll("span,div,p,strong").forEach(t => {
          if (t.children.length || t.closest(".cart__product-name-price,.pa-free-price,.quantity,.pa-cart-page-actions")) return;
          const a = t.textContent.trim(),
            r = t.getBoundingClientRect();
          /^₹\s?[\d,]+(?:\.\d{1,2})?$/.test(a) && r.left > o.left + o.width * .78 && t.style.setProperty("display", "none", "important");
        });
      });
    }
    header(e) {
      const t = this.drawer.querySelector(".drawer__heading .cart-count");
      t && (t.dataset.paOriginalCount || (t.dataset.paOriginalCount = t.textContent.trim()), t.textContent = e < 100 ? e : "~", t.title = "Qualifying products");
    }
    lock(e, t = null) {
      var i;
      const a = (i = e == null ? void 0 : e.querySelector) == null ? void 0 : i.call(e, ".quantity.cart-quantity");
      if (!a) return;
      const r = a.querySelector("input.quantity__input");
      a.classList.contains("pa-quantity-locked") && (t === null || g(r == null ? void 0 : r.value) === g(t)) || (a.classList.add("pa-quantity-locked"), a.setAttribute("aria-disabled", "true"), r && ("paOriginalName" in r.dataset || (r.dataset.paOriginalName = r.getAttribute("name") || "", r.dataset.paOriginalIndex = r.getAttribute("data-index") || "", r.dataset.paOriginalVariant = r.getAttribute("data-quantity-variant-id") || ""), t !== null && (r.value = t), r.disabled = r.readOnly = !0, r.setAttribute("aria-disabled", "true"), r.tabIndex = -1, r.removeAttribute("name"), r.removeAttribute("data-index"), r.removeAttribute("data-quantity-variant-id")), a.querySelectorAll(".quantity__button").forEach(s => {
        s.disabled = !0, s.setAttribute("aria-disabled", "true"), s.tabIndex = -1;
      }));
    }
    unlock(e) {
      var r;
      const t = (r = e == null ? void 0 : e.querySelector) == null ? void 0 : r.call(e, ".quantity.cart-quantity");
      if (!t) return;
      t.querySelectorAll('.quantity__button[data-pa-promo-minus-locked="true"]').forEach(i => {
        i.disabled = !1, i.removeAttribute("aria-disabled"), i.removeAttribute("tabindex"), delete i.dataset.paPromoMinusLocked;
      });
      if (!t.classList.contains("pa-quantity-locked")) return;
      t.classList.remove("pa-quantity-locked"), t.removeAttribute("aria-disabled");
      const a = t.querySelector("input.quantity__input");
      a && ("paOriginalName" in a.dataset && (a.dataset.paOriginalName && (a.name = a.dataset.paOriginalName), a.dataset.paOriginalIndex && (a.dataset.index = a.dataset.paOriginalIndex), a.dataset.paOriginalVariant && (a.dataset.quantityVariantId = a.dataset.paOriginalVariant), delete a.dataset.paOriginalName, delete a.dataset.paOriginalIndex, delete a.dataset.paOriginalVariant), a.disabled = a.readOnly = !1, a.removeAttribute("aria-disabled"), a.removeAttribute("tabindex")), t.querySelectorAll(".quantity__button").forEach(i => {
        i.disabled = !1, i.removeAttribute("aria-disabled"), i.removeAttribute("tabindex");
      });
    }
    promoFreeQty(e, t = 1) {
      var s;
      this.unlock(e);
      const a = (s = e == null ? void 0 : e.querySelector) == null ? void 0 : s.call(e, ".quantity.cart-quantity");
      if (!a) return;
      const r = [...a.querySelectorAll(".quantity__button")],
        i = a.querySelector('.quantity__button[name="minus"],button[name="minus"],[data-action="minus"],[data-quantity-minus]') || r[0];
      if (i && Math.max(0, Math.floor(g(t, 1))) <= 1) i.disabled = !0, i.setAttribute("aria-disabled", "true"), i.tabIndex = -1, i.dataset.paPromoMinusLocked = "true";
    }
    complimentary(e) {
      e.forEach(t => {
        var s;
        const a = this.freebieIds.has(t.variantId),
          r = t.complimentary;
        t.element.classList.toggle("pa-complimentary-line", r), a ? t.element.dataset.paConfiguredFreebie = "true" : delete t.element.dataset.paConfiguredFreebie;
        let i = t.element.querySelector(".pa-complimentary-badge");
        r ? (this.lock(t.element, t.quantity), i || (i = document.createElement("span"), i.className = "pa-complimentary-badge", i.textContent = "FREE", (s = this.isCartPage ? t.element.querySelector(".cart__product-name-price") : t.element.querySelector(".cart-item-info")) == null || s.appendChild(i))) : (this.unlock(t.element), i == null || i.remove());
      });
    }
    giftStrikePrices(lines) {
      // Display the configured free gift's catalog value without affecting cart totals.
      for (const line of lines) {
        const card = line.element;
        let strike = card.querySelector(".pa-gift-compare-price");
        const gift = this.config.freebies.find(item =>
          String(item.variantId || "") === String(line.variantId || ""));
        const mrp = gift ? Math.max(0, g(gift.price), g(gift.compareAtPrice)) : 0;
        if (!line.complimentary || !gift || !mrp || card.classList.contains("pa-line-fully-free")) {
          strike?.remove();
          continue;
        }
        const priceRoot = card.querySelector(
          ".cart-item-prices .heading-color, .cart-item__discounted-prices, .cart-item-prices, .cart__product-name-price .cart-item__price-wrapper, .cart__product-name-price");
        if (!priceRoot) continue;
        const nativeStrike = priceRoot.querySelector("s.compare-at-price, s.cart-item__old-price");
        if (nativeStrike && nativeStrike.textContent.trim()) {
          strike?.remove();
          continue;
        }
        if (!strike) {
          strike = document.createElement("s");
          strike.className = "pa-gift-compare-price";
          priceRoot.appendChild(strike);
        } else if (strike.parentElement !== priceRoot) {
          priceRoot.appendChild(strike);
        }
        const formatted = C(mrp, this.currency);
        if (strike.textContent !== formatted) strike.textContent = formatted;
      }
    }
    label(e) {
      if (!e) return "";
      if (e.type === "freebie") return "Free Bag";
      if (e.type === "free") {
        const t = Math.max(0, Math.floor(g(e.value)));
        return `${t} Free ${t === 1 ? "Item" : "Items"}`;
      }
      return `${g(e.value)}% Off`;
    }
    messageLabel(e) {
      return this.label(e);
    }
    icon(e) {
      return ["free", "freebie"].includes((e == null ? void 0 : e.type)) ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 10h16v11H4zM3 6.5h18V10H3zM12 6.5V21M12 6.5H8.8a2.3 2.3 0 1 1 0-4.6c2.4 0 3.2 4.6 3.2 4.6Zm0 0h3.2a2.3 2.3 0 1 0 0-4.6C12.8 1.9 12 6.5 12 6.5Z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>' : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 2.8 2 1.35 2.38-.28.98 2.18 2.18.98-.28 2.38 1.35 2-1.35 2 .28 2.38-2.18.98-.98 2.18-2.38-.28-2 1.35-2-1.35-2.38.28-.98-2.18-2.18-.98.28-2.38-1.35-2 1.35-2-.28-2.38 2.18-.98.98-2.18 2.38.28 2-1.35Z" fill="none" stroke="currentColor" stroke-width="1.45" stroke-linejoin="round"/><path d="m8.7 15.3 6.6-6.6" fill="none" stroke="currentColor" stroke-width="1.55" stroke-linecap="round"/><circle cx="9.1" cy="9.2" r="1.15" fill="none" stroke="currentColor" stroke-width="1.35"/><circle cx="14.9" cy="14.8" r="1.15" fill="none" stroke="currentColor" stroke-width="1.35"/></svg>';
    }
    panel(e, t, a) {
      const r = this.drawer.querySelector("[data-pa-offer-ui]");
      if (!r) return;
      r.hidden = !1;
      const i = r.querySelector("[data-pa-offer-status]");
      if (i) {
        const n = String(e && e.statusSuffix || this.config.statusSuffix || "").trim();
        if (e) {
          const c = P(this.config.unlockTemplate || "{reward} Unlocked", {
            reward: this.messageLabel(e)
          }).replace(/\bunlocked\b/i, "Unlocked");
          i.textContent = c && n ? `${c} | ${n}` : c, i.classList.add("is-unlocked");
        } else {
          i.textContent = n, i.classList.remove("is-unlocked");
        }
      }
      const s = r.querySelector("[data-pa-offer-nudge]");
      if (s) {
        if (t) {
          if (t.basis === "order_value") {
            const c = Math.max(0, t.amount - a.eligibleTotal);
            s.textContent = P(this.config.valueNudgeTemplate || "Add {amount} more to unlock {reward}", {
              amount: C(c, this.currency),
              reward: this.messageLabel(t)
            });
          } else {
            const c = Math.max(0, t.qty - a.eligibleQuantity);
            s.textContent = P(this.config.nudgeTemplate || "Add {count} more {items} to unlock {reward}", {
              count: c,
              items: c === 1 ? "item" : "items",
              reward: this.messageLabel(t)
            });
          }
        } else s.textContent = "Best Offer Unlocked!";
        s.hidden = !1;
      }
      this.milestones(a, e);
    }
    milestones(e, t) {
      const a = this.drawer.querySelector("[data-pa-milestones]");
      if (!a) return;
      const rCount = Math.max(1, this.config.tiers.length);
      a.style.setProperty("--pa-tier-count", String(rCount)), a.style.setProperty("--pa-track-inset", `${50 / rCount}%`);
      const firstTier = this.config.tiers[0];
      let firstProgress = 0;
      if (firstTier) {
        const currentValue = firstTier.basis === "order_value" ? e.eligibleTotal : e.eligibleQuantity,
          firstTarget = firstTier.basis === "order_value" ? Math.max(0, g(firstTier.amount)) : Math.max(1, g(firstTier.qty, 1));
        firstProgress = firstTarget <= 0 ? 1 : Math.max(0, Math.min(1, currentValue / firstTarget));
      }
      a.style.setProperty("--pa-first-progress", String(firstProgress));
      a.querySelectorAll("[data-pa-tier-index]").forEach(i => {
        const s = this.tierMap.get(g(i.dataset.paTierIndex, -1));
        if (!s) {
          i.hidden = !0;
          return;
        }
        const c = this.tierMet(s, e.eligibleQuantity, e.eligibleTotal);
        i.hidden = !1, i.classList.toggle("is-unlocked", c), i.classList.toggle("is-current", (t == null ? void 0 : t.originalIndex) === s.originalIndex);
        const n = i.querySelector("[data-pa-dot]");
        n && n.dataset.paIconType !== s.type && (n.innerHTML = this.icon(s), n.dataset.paIconType = s.type);
        const o = i.querySelector(".pa-milestone__qty");
        o && (o.textContent = s.basis === "order_value" ? C(s.amount, this.currency) : `${s.qty} ${s.qty === 1 ? "Item" : "Items"}`);
        const p = i.querySelector("[data-pa-tier-label]"),
          h = this.label(s);
        p && p.textContent !== h && (p.textContent = h);
      });
      const rFill = a.querySelector("[data-pa-progress-fill]");
      rFill && (rFill.style.width = `${this.progress(e)}%`);
    }
    progress(e) {
      const t = this.config.tiers;
      if (!t.length) return 0;
      const a = t.map(s => this.tierMet(s, e.eligibleQuantity, e.eligibleTotal));
      if (t.length === 1) return a[0] ? 100 : 0;
      let r = -1;
      a.forEach((s, c) => {
        s && (r = c);
      });
      if (r < 0) return 0;
      if (r >= t.length - 1) return 100;
      let i = -1;
      for (let s = r + 1; s < t.length; s += 1) if (!a[s]) {
        i = s;
        break;
      }
      if (i < 0) return 100;
      const s = 100 / (t.length - 1),
        c = Math.max(0, r * s),
        n = t[r],
        o = t[i];
      if (!n || n.basis !== o.basis) return c;
      const p = o.basis === "order_value" ? e.eligibleTotal : e.eligibleQuantity,
        h = n.basis === "order_value" ? Math.max(0, g(n.amount)) : Math.max(1, g(n.qty, 1)),
        u = o.basis === "order_value" ? Math.max(0, g(o.amount)) : Math.max(1, g(o.qty, 1)),
        m = Math.max(1, u - h),
        y = Math.max(0, Math.min(1, (p - h) / m));
      return Math.min(100, c + y * s);
    }
    cleanup(e) {
      e.element.classList.remove("pa-line-fully-free", "pa-line-partially-free"), e.element.querySelectorAll(".pa-free-price,.pa-paid-free-note,.pa-paid-quantity-display").forEach(t => t.remove()), e.element.querySelectorAll(".quantity__input.pa-paid-quantity-source").forEach(t => t.classList.remove("pa-paid-quantity-source")), e.complimentary || this.unlock(e.element);
    }
    showPaidQty(e, t) {
      var s, c;
      const a = (s = e == null ? void 0 : e.querySelector) == null ? void 0 : s.call(e, ".quantity.cart-quantity"),
        r = (c = a == null ? void 0 : a.querySelector) == null ? void 0 : c.call(a, "input.quantity__input");
      if (!a || !r) return;
      r.classList.add("pa-paid-quantity-source");
      let i = a.querySelector(".pa-paid-quantity-display");
      i || (i = document.createElement("span"), i.className = "pa-paid-quantity-display", i.setAttribute("aria-hidden", "true"), a.appendChild(i)), i.textContent = Math.max(0, t);
    }
    position(e) {
      var y, S;
      const t = (S = (y = e[0]) == null ? void 0 : y.element) == null ? void 0 : S.parentElement;
      if (!t) return;
      const a = [...e].filter(d => !d.complimentary && !d.element.classList.contains("pa-line-fully-free")).sort((d, f) => d.lineIndex - f.lineIndex),
        r = [...e].filter(d => !d.complimentary && d.element.classList.contains("pa-line-fully-free")).sort((d, f) => d.lineIndex - f.lineIndex),
        i = [...t.querySelectorAll("[data-pa-free-allocation]")],
        s = [...e].filter(d => d.complimentary).sort((d, f) => d.lineIndex - f.lineIndex),
        c = new Map(),
        n = [];
      i.forEach(d => {
        const f = String(d.dataset.paSourceLineKey || "");
        if (!f) {
          n.push(d);
          return;
        }
        c.has(f) || c.set(f, []), c.get(f).push(d);
      });
      const o = new Map(),
        p = [];
      r.forEach(d => {
        const f = a.filter(I => String(I.variantId || "") === String(d.variantId || ""));
        if (!f.length) {
          p.push(d.element);
          return;
        }
        const b = f.filter(I => I.lineIndex <= d.lineIndex).sort((I, F) => F.lineIndex - I.lineIndex)[0] || f[0],
          q = String(b.lineKey || "");
        if (!q) {
          p.push(d.element);
          return;
        }
        o.has(q) || o.set(q, []), o.get(q).push(d.element);
      });
      const h = [];
      a.forEach(d => {
        h.push(d.element);
        const f = String(d.lineKey || "");
        h.push(...(o.get(f) || []), ...(c.get(f) || []));
      }), h.push(...p, ...n, ...s.map(d => d.element));
      const u = h.filter(d => (d == null ? void 0 : d.parentElement) === t),
        m = [...t.children].filter(d => {
          var f, w;
          return ((f = d.matches) == null ? void 0 : f.call(d, x)) || ((w = d.matches) == null ? void 0 : w.call(d, "[data-pa-free-allocation]"));
        });
      m.length === u.length && m.every((d, f) => d === u[f]) || (this.drawer._paOrdering = !0, u.forEach(d => t.appendChild(d)), setTimeout(() => {
        this.drawer && (this.drawer._paOrdering = !1);
      }, 0));
    }
    allocations(e, t, a) {
      const r = (t == null ? void 0 : t.type) === "free" ? `${t.code || ""}|${e.map(n => `${n.lineKey}:${n.quantity}:${n.unitPrice}:${a.freeByLine.get(n.lineIndex) || 0}`).join("|")}` : "none",
        i = (t == null ? void 0 : t.type) === "free" ? e.filter(n => {
          const o = a.freeByLine.get(n.lineIndex) || 0;
          return o > 0 && o < n.quantity;
        }).length : 0,
        s = this.drawer.querySelectorAll(".pa-free-allocation-row,[data-pa-free-allocation]").length;
      if (this._allocationSig === r && (!this.isCartPage || s === i)) {
        (t == null ? void 0 : t.type) === "free" && e.forEach(n => {
          const o = a.freeByLine.get(n.lineIndex) || 0;
          o && (o >= n.quantity ? this.promoFreeQty(n.element, n.quantity) : this.showPaidQty(n.element, Math.max(0, n.quantity - o)));
        }), this.position(e);
        return;
      }
      this._allocationSig = r, this.drawer.querySelectorAll(".pa-free-allocation-row,[data-pa-free-allocation]").forEach(n => n.remove()), e.forEach(n => this.cleanup(n)), (t == null ? void 0 : t.type) === "free" && e.forEach(n => {
        const o = a.freeByLine.get(n.lineIndex) || 0;
        o && (o >= n.quantity ? this.fullFree(n, o) : this.partialFree(n, o));
      }), this.position(e);
    }
    fullFree(e, t) {
      e.element.classList.add("pa-line-fully-free", "pa-free-product-card"), this.promoFreeQty(e.element, e.quantity);
      const r = this.isCartPage ? e.element.querySelector(".cart__product-name-price") : e.element.querySelector(".cart-item-info");
      if (!r) return;
      r.querySelectorAll(".pa-free-price,.pa-paid-free-note").forEach(c => c.remove());
      const i = document.createElement("div");
      i.className = "pa-free-price", i.innerHTML = `<span class="pa-free-zero">₹0.00</span><s>${C(e.mrpUnitPrice * t, this.currency)}</s>`, r.appendChild(i);
      const s = document.createElement("div");
      s.className = "pa-paid-free-note", s.textContent = "FREE", r.appendChild(s);
    }
    partialFree(e, t) {
      e.element.classList.add("pa-line-partially-free");
      const r = Math.max(0, e.quantity - t),
        i = this.isCartPage ? ".cart__product-name-price" : ".cart-item-info";
      e.element.querySelector(i)?.querySelectorAll(".pa-paid-free-note").forEach(p => p.remove());
      this.showPaidQty(e.element, r);
      const s = e.element.cloneNode(!0);
      ["id", "data-pa-cart-line", "data-pa-line-index", "data-pa-line-key", "data-pa-product-id", "data-pa-variant-id", "data-pa-title", "data-pa-quantity", "data-pa-unit-price", "data-pa-line-total", "data-pa-eligible", "data-pa-complimentary", "data-pa-managed"].forEach(o => s.removeAttribute(o)), s.classList.remove("pa-line-partially-free", "pa-line-fully-free", "pa-complimentary-line", "border-bottom-dashed"), s.classList.add("pa-free-allocation-row", "pa-free-allocation-card", "pa-free-product-card"), s.dataset.paFreeAllocation = "true", s.dataset.paSourceLineKey = e.lineKey || "", s.dataset.paSourceVariantId = e.variantId || "", s.setAttribute("aria-label", `${e.title} Free Item`), s.querySelectorAll("[id]").forEach(o => o.removeAttribute("id")), s.querySelectorAll("label[for]").forEach(o => o.removeAttribute("for")), s.querySelectorAll("cart-remove-button,main-cart-remove-button,main-cart-edit").forEach(o => o.remove());
      const c = this.isCartPage ? s : s.querySelector(".cart-item-info .space-between") || s.querySelector(".cart-item-info") || s;
      if (c) {
        const o = document.createElement("button");
        o.type = "button", o.className = "btn-reset pointer inline-flex align-center flex-end w-30 hover-icon-zoom relative not-highlight-tap pa-remove-free-product", o.dataset.paRemoveFreeProduct = "true", o.dataset.paSourceLineKey = e.lineKey, o.setAttribute("aria-label", `Remove ${e.title}`), o.innerHTML = '<svg width="16" height="16" viewBox="0 0 20 20" fill="none" class="icon-zoom transition-short will-change text-color"><use href="#icon-trash-cart"></use></svg>', c.appendChild(o);
      }
      s.querySelectorAll(".pa-paid-free-note,.pa-complimentary-badge,.pa-free-price,.pa-paid-quantity-display,.cart-item__error").forEach(o => o.remove()), s.querySelectorAll(".quantity__input.pa-paid-quantity-source").forEach(o => o.classList.remove("pa-paid-quantity-source")), s.querySelectorAll(".cart-item-prices,.cart-item__discounted-prices,.cart-item__price-wrapper,.discounts,.unit-price").forEach(o => o.remove());
      const n = this.isCartPage ? s.querySelector(".cart__product-name-price") : s.querySelector(".cart-item-info");
      if (n) {
        const o = document.createElement("div");
        o.className = "pa-free-price", o.innerHTML = `<span class="pa-free-zero">₹0.00</span><s>₹${(e.mrpUnitPrice * t / 100).toFixed(2)}</s>`, n.appendChild(o);
        const p = document.createElement("div");
        p.className = "pa-paid-free-note", p.textContent = "FREE", n.appendChild(p);
      }
      this.lock(s, t), e.element.insertAdjacentElement("afterend", s);
    }
    compactSummary(summary) {
      // Move only our coupon node. Keep app-owned content and its containers intact.
      const row = summary.querySelector(".pa-summary-savings-row");
      const coupon = summary.querySelector(".pa-summary-coupon");
      const saved = summary.querySelector("[data-pa-total-saved]");
      if (row && coupon) {
        if (saved && saved.parentElement === row) saved.replaceWith(coupon);
        else if (coupon.parentElement !== row) row.insertBefore(coupon, row.firstChild);
      }
      summary.querySelectorAll("[data-pa-total-saved],.pa-summary-free-shipping").forEach(node => node.remove());
      summary.querySelectorAll(".pa-summary-meta-row").forEach(row => {
        // Do not remove this wrapper if an app has added any content to it.
        if (!row.children.length && !row.textContent.trim()) row.remove();
      });
    }
    summary(tier, totals, lines) {
      // One clear comparison: paid products' full MRP vs. estimated payable total.
      // Exclude promotional gift lines to avoid inflating savings.
      const summaries = [...this.drawer.querySelectorAll("[data-pa-offer-summary]")];
      const natives = [...this.drawer.querySelectorAll("[data-pa-native-total]")];
      if (!summaries.length && !natives.length) return;
      const paidLines = lines.filter(line => !line.complimentary && line.quantity > 0);
      if (!paidLines.length) {
        summaries.forEach(node => { node.hidden = true; });
        natives.forEach(node => { node.hidden = false; });
        return;
      }
      const mrpTotal = Math.max(totals.rawTotal,
        paidLines.reduce((sum, line) => sum + Math.max(0, line.lineTotal, line.mrpLineTotal), 0));
      const finalTotal = Math.max(0, totals.finalTotal);
      const totalSavings = Math.max(0, mrpTotal - finalTotal);
      summaries.forEach(summary => {
        const mrp = summary.querySelector("[data-pa-mrp-total]");
        const savings = summary.querySelector("[data-pa-total-savings]");
        const savingsRow = summary.querySelector("[data-pa-savings-row]");
        const final = summary.querySelector("[data-pa-final-total]");
        if (mrp) mrp.textContent = C(mrpTotal, this.currency);
        if (savings) savings.textContent = `−${C(totalSavings, this.currency)}`;
        const existing = summary.querySelector(".pa-savings-coupon");
        const code = tier && tier.type === "percent" && tier.value > 0
          ? String(tier.code || "").trim() : "";
        const hasCoupon = Boolean(code && totals.discountAmount > 0 && totalSavings > 0);
        if (savingsRow) {
          // Keep the savings amount on the right and replace only its label with the coupon.
          savingsRow.hidden = totalSavings <= 0;
          const label = savingsRow.querySelector(":scope > span:first-child");
          if (label) label.hidden = hasCoupon;
          if (!hasCoupon) {
            existing?.remove();
          } else {
            const badge = existing || document.createElement("span");
            badge.className = "pa-savings-coupon";
            // Insert before the amount, including when moving it from Estimated Total.
            if (savings) savingsRow.insertBefore(badge, savings);
            else savingsRow.appendChild(badge);
            const title = `${code} Applied`;
            if (badge.textContent !== title) badge.textContent = title;
            badge.setAttribute("aria-label", `Coupon ${code} automatically applied at checkout`);
            badge.title = `Coupon ${code} automatically applied at checkout`;
          }
        } else {
          existing?.remove();
        }
        if (final) final.textContent = C(finalTotal, this.currency);
        summary.hidden = false;
      });
      natives.forEach(node => { node.hidden = true; });
    }
  }
  const L = new WeakMap();
  let j = 0;
  const Z = (l = 40) => {
      clearTimeout(j), j = setTimeout(() => {
        const e = document.querySelector(E);
        e && v(e);
      }, l);
    },
    v = l => {
      if (!(l instanceof Element)) return;
      let t = L.get(l);
      t ? t.render() : (t = new J(l), L.set(l, t));
    },
    k = () => document.querySelectorAll(A).forEach(e => v(e));
  const paDrawerOpenState = new WeakMap(),
    paDrawerOpenFallback = new WeakMap(),
    paIsDrawerOpen = l => {
      if (!(l instanceof Element) || !l.isConnected || l.hidden || l.getAttribute("aria-hidden") === "true") return !1;
      if (l.hasAttribute("open") || l.getAttribute("aria-hidden") === "false") return !0;
      const e = String(l.className || "").toLowerCase();
      if (/(^|\s)(active|open|opened|is-open|is-active|show|shown|visible)(\s|$)/.test(e)) return !0;
      try {
        const t = getComputedStyle(l);
        if (t.display === "none" || t.visibility === "hidden") return !1;
        const a = l.getBoundingClientRect();
        return a.width > 1 && a.height > 1 && a.right > 1 && a.bottom > 1 && a.left < window.innerWidth - 1 && a.top < window.innerHeight - 1;
      } catch {
        return !1;
      }
    },
    paRefreshDrawerPrices = l => {
      if (!(l instanceof Element) || !l.isConnected || !l.matches(_)) return;
      v(l);
      const e = L.get(l);
      e && e.refreshFromServer();
    },
    paHandleDrawerState = l => {
      if (!(l instanceof Element) || !l.matches(_)) return;
      cancelAnimationFrame(paDrawerOpenFallback.get(l) || 0);
      const e = requestAnimationFrame(() => {
        paDrawerOpenFallback.delete(l);
        const t = paIsDrawerOpen(l),
          a = paDrawerOpenState.get(l) === !0;
        paDrawerOpenState.set(l, t), t && !a && paRefreshDrawerPrices(l);
      });
      paDrawerOpenFallback.set(l, e);
    };
  let V = 0,
    H = 0;
  const ee = () => {
      const l = document.querySelector(_);
      if (!l) return "drawer";
      const e = l.dataset.paMobileAddBehavior;
      return e === "message" || e === "drawer" ? e : l.dataset.paOpenOnAdd === "false" ? "message" : "drawer";
    },
    te = () => {
      const l = new Date(Date.now() + 864e5).toUTCString();
      document.cookie = `cart_message=true; expires=${l}; path=/; SameSite=Lax`;
    },
    T = () => {
      var t;
      if (window.innerWidth > 767) return;
      const l = ee(),
        e = (t = window.themeGlobalVariables) == null ? void 0 : t.settings;
      e && (e.actionAddCartMobile = l === "drawer" ? "mini_cart" : "cart_message"), l === "message" && te();
    },
    K = l => {
      !(l instanceof Element) || !l.isConnected || l._paInternalMutation || l.classList.contains("cart-update") || (cancelAnimationFrame(V), V = requestAnimationFrame(() => {
        !l.isConnected || l._paInternalMutation || l.classList.contains("cart-update") || v(l);
      }));
    },
    Q = l => {
      !(l instanceof Element) || !l.isConnected || l._paInternalMutation || (cancelAnimationFrame(H), H = requestAnimationFrame(() => {
        !l.isConnected || l._paInternalMutation || v(l);
      }));
    };
  const paRefreshCartPage = () => {
    const l = document.querySelector(E);
    if (!l) return;
    v(l);
    const e = L.get(l);
    e && e.refreshFromServer();
  };
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", () => {
    T(), k(), paRefreshCartPage();
  }, {
    once: !0
  }) : (T(), k(), paRefreshCartPage()), window.addEventListener("load", () => {
    T(), k(), Z(60);
  }, {
    once: !0
  }), window.addEventListener("pageshow", () => {
    requestAnimationFrame(() => {
      k(), Z(40);
    });
  }), document.addEventListener("submit", l => {
    var t, a;
    const e = (a = (t = l.target) == null ? void 0 : t.closest) == null ? void 0 : a.call(t, 'form[action*="/cart/add"]');
    !e || e.closest(A) || T();
  }, !0), document.addEventListener("click", l => {
    const e = l.target instanceof Element ? l.target : null;
    if (!e) return;
    const paCartTrigger = e.closest('a[href$="/cart"],a[href*="/cart?"],[data-cart-drawer-open],[data-open-cart],[aria-controls*="cart" i]');
    if (paCartTrigger && !paCartTrigger.closest(A)) setTimeout(() => {
      const paDrawer = document.querySelector(_);
      paDrawer && (paDrawerOpenState.set(paDrawer, !0), paRefreshDrawerPrices(paDrawer));
    }, 0);
    const t = e.closest(E) || e.closest(_);
    if (t && t.matches(_) && e.closest('[is="button-close-model"],modal-overlay') || t && e.closest(".quantity__button")) return;
    if (t) {
      const r = e.closest("[data-pa-remove-free-product]");
      if (r && t.contains(r)) {
        const i = L.get(t),
          s = r.dataset.paSourceLineKey || "",
          c = [...t.querySelectorAll(x)].find(n => n.dataset.paLineKey === s);
        if (i && c && s) {
          l.preventDefault(), l.stopImmediatePropagation();
          const n = c.querySelector("input.quantity__input"),
            o = Math.max(0, g(c.dataset.paQuantity, g(n == null ? void 0 : n.value)));
          i.changeLine(s, Math.max(0, o - 1));
          return;
        }
      }
    }
    if (t) {
      const r = e.closest("cart-remove-button,main-cart-remove-button");
      if (r && t.contains(r)) {
        const i = r.closest(x),
          s = L.get(t),
          c = (i == null ? void 0 : i.dataset.paLineKey) || "";
        if (s && i && c) {
          const n = String(i.dataset.paVariantId || "");
          if (i.dataset.paConfiguredFreebie === "true" || s.freebieIds.has(n)) return;
          l.preventDefault(), l.stopImmediatePropagation();
          s.changeLine(c, 0);
          return;
        }
      }
    }
    e.closest('[name="add"],[data-add-to-cart],[data-action-add-cart],.quick-add__submit,product-form button[type="submit"],button.product-form__submit') && !t && T();
  }, !0);
  const se = new WeakMap(),
    fe = l => {
      if (!(l instanceof Element) || se.has(l)) return;
      const e = l.matches(_),
        t = l.matches(E),
        a = new MutationObserver(r => {
          for (const i of r) {
            const s = i.target instanceof Element ? i.target : null;
            if (!s) continue;
            if (i.type === "attributes") {
              s === l && e && (paHandleDrawerState(l), !l._paInternalMutation && !l.classList.contains("cart-update") && K(l));
              continue;
            }
            if (i.type !== "childList" || l._paOrdering) continue;
            const nativeRowsChanged = [...i.addedNodes, ...i.removedNodes].some(node =>
              node instanceof Element && (node.matches(x) || node.querySelector(x))
            );
            if (nativeRowsChanged && !l._paInternalMutation) {
              e ? K(l) : Q(l);
              continue;
            }
            if (e && !l._paInternalMutation && !l.classList.contains("cart-update") && (s.matches(".cart-drawer__form") || s.matches(".drawer__body"))) {
              K(l);
              continue;
            }
            t && !l._paInternalMutation && (s.matches(".main-cart-items") || s.matches(".main-cart__wrapper")) && Q(l);
          }
        });
      e && paDrawerOpenState.set(l, paIsDrawerOpen(l));
      a.observe(l, e ? {
        childList: !0,
        subtree: !0,
        attributes: !0,
        attributeFilter: ["class", "style", "aria-hidden", "hidden", "open"]
      } : {
        childList: !0,
        subtree: !0
      }), se.set(l, a);
    },
    he = l => {
      fe(l), l.matches(_) ? K(l) : l.matches(E) && Q(l);
    },
    ae = new MutationObserver(l => {
      for (const e of l) if (e.type === "childList") for (const t of e.addedNodes) t instanceof Element && (t.matches("cart-drawer") && he(t), t.matches(E) && he(t), t.querySelectorAll(`cart-drawer,${E}`).forEach(he));
    }),
    U = () => {
      if (!document.body) return;
      document.querySelectorAll(`cart-drawer,${E}`).forEach(fe), ae.observe(document.body, {
        childList: !0,
        subtree: !0
      });
    };
  document.body ? U() : document.addEventListener("DOMContentLoaded", U, {
    once: !0
  });
})();

/* Pure Alchemy product pairing: manual swipe/click only; no auto-advance. */
(() => {
  "use strict";
  if (window.__paCompactCarouselReady) return;
  window.__paCompactCarouselReady = true;
  const selector = "[data-pa-compact-carousel]";
  const initialized = new WeakSet();
  function setup(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    const viewport = root.querySelector(".pa-compact-upsell__viewport");
    const slides = Array.from(root.querySelectorAll("[data-pa-upsell-slide]"));
    if (!viewport || !slides.length) {
      root.hidden = true;
      return;
    }
    root.dataset.paSingle = slides.length === 1 ? "true" : "false";
    const move = direction => {
      const slide = slides[0];
      if (!slide) return;
      const width = slide.getBoundingClientRect().width;
      viewport.scrollBy({ left: direction * (width + 10), behavior: "smooth" });
    };
    root.querySelector("[data-pa-upsell-prev]")?.addEventListener("click", () => move(-1));
    root.querySelector("[data-pa-upsell-next]")?.addEventListener("click", () => move(1));
  }
  function scan(node) {
    if (!(node instanceof Element)) return;
    if (node.matches(selector)) setup(node);
    node.querySelectorAll(selector).forEach(setup);
  }
  const start = () => {
    document.querySelectorAll(selector).forEach(setup);
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(scan));
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else start();
})();
